import { render, staticRenderFns } from "./ChatBotIcon.vue?vue&type=template&id=4de42468&scoped=true&lang=pug"
import script from "./ChatBotIcon.vue?vue&type=script&lang=ts"
export * from "./ChatBotIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChatBotIcon.vue?vue&type=style&index=0&id=4de42468&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de42468",
  null
  
)

export default component.exports